<template>
	<div class="emb-register-wrap section-gap">
		<div class="container py-0">
			<v-layout row wrap align-center justify-center>
				<v-flex sm12 md12 lg8 xl7>
					<v-layout row mx-sm-0 mx-3  wrap align-center justify-center>
						<v-flex sm6 md7 lg6 xl6 hidden-sm-and-down>
							<div class="form-img register-image" :style="'background-image: url('+ signupSection.Image_800x1202_px +');'"></div>
						</v-flex>
						<v-flex sm10 md5 lg6 xl6>
							<div class="emb-card sign-in-form form-margin d-block white pa-6">
								<div v-show="visible2">
								<h4>{{signupSection.Form_Title}}</h4>
								<v-form  >
									<v-text-field
									   v-model="fName"
										type="text"
										:placeholder="signupSection.Firstname_Placeholder"
									
									>
									</v-text-field>
									<v-text-field
									     v-model="lName"
										type="text"
										:placeholder="signupSection.Last_Name_Placeholder"
										
									>
									</v-text-field>
											<v-text-field
									     v-model="userName"
										type="text"
										:placeholder="signupSection.Username_Placeholder">
										</v-text-field>
										<div class="container">
										<div class="row">
										<div class="col-1 countrycode">
											 <v-select  @click="cnList"  label="Code" :items="cntryCodes" v-model="selectedOption"> 						                                 
									  </v-select>
										</div>
									  <div class="col-3">
                                        <v-text-field
									     v-model="contact"
											type="text"
										:placeholder="signupSection.Phone_Number_Placeholder">
										</v-text-field>
										</div>
										</div>
                                        </div>
									   
										<v-text-field
									    v-model="pass"
										:type="typeName"
										:placeholder="signupSection.Type_Password_Placeholder">
										</v-text-field>
										<v-checkbox
											v-model="checkedvalue"
											label="View Password"
											@change="check">
											</v-checkbox>
										  <v-text-field
										class="mb-4"
									    v-model="confirmPass"
										type="password"
										:placeholder="signupSection.Confirm_Password_Placeholder"
										>
									</v-text-field>
									<v-btn class="accent mx-0 mb-4" large  @click.stop.prevent="saveDetails">
										{{signupSection.Sign_Up_Button_Label}}
									</v-btn>
									 <p>{{signupSection.Already_have_account_label}}<router-link :to="signupSection.Sign_In_Path" class="accent--text">{{signupSection.Sign_In_Label}} </router-link></p>
								</v-form>
								</div>
                                  <div v-show="visible1">
									  <v-form>
								     <div style="margin-left: 300px ">
										</div>			
									  <p clas="otp-sytle">{{otpSection.Title}}</p>
									  <v-text-field
							           v-model="otp"
										type="text"
										:placeholder="otpSection.Placeholder">
										</v-text-field>
										<div style="margin-left: 150px">
									<a href="/home"> <v-btn  class="accent ma-0">{{otpSection.Button_Label}}</v-btn> </a>
										</div>
									  </v-form>
                                  </div>
							</div>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</div>
   </div>
</template>
	
<script>
   import Vue from 'vue';
   import gettingRestClientObject from "../../../services/utils/cms-helper" ;
//    import "../../assets/css/commonstylesheet.css";
   import 'vue-toast-notification/dist/theme-default.css';
   import VueToast from "vue-toast-notification";
Vue.use(VueToast, {
  position: "top-right"
});
	export default{
   	data () {
      	return {
         	valid: false,
     		signupSection:'',
			cmsRequestFunctions:'',
			fName:'',
			lName:'',
			userName:'',
			pass:'',
		   confirmPass:'',
		   paswd:'',
		   checkedvalue:'',
		   countryList:[],
		   cntryCodes:[],
		   visible1:false,
		   visible2:true,
		   typeName:'password',
		   selectedOption:'',
		   otp:'',
		   contact:'',
		   usercnt:'',
		   otpSection:''
         }
	  },
	  mounted() {
	
	this.cmsRequestFunctions = gettingRestClientObject();
	this.getPageData();
  },
      methods: {
         saveDetails(){
	   
	 if (this.fName=='') {
       Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M005'));
           return false;
	  }
	   if (this.lName=='') {
       Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M006'));   
       return false;
	  }
	    
	  if (this.userName=='') {
          Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M015'));
        
       return false;
	  } 
	  
	  if(this.contact=='')
	  {
    Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M011'));
        return false;   
		  }
		 
	  if(this.pass=='')
	   { 
      Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M009'));
        return false;   

	   }
	 
	    if(this.confirmPass=='')
	   { 
	
	  Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M011'));     
	    return false;   

	   }
			  if(this.pass!=this.confirmPass){
              Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M008'));

            return false;
				  
			  }
	
					this.visible1=true;
					this.visible2=false;
				Vue.$toast.success(self.cmsRequestFunctions.getValidationMsgByCode('M014'));
        	
			},
			check(){
            if (this.checkedvalue==true){

           this.typeName='text';

			}
			else{
           this.typeName='password';

			}
          
			},
cnList(){

var self;
self.usercnt=self.contact.concat(self.selectedOption);

},


			getPageData: function() {
  
var self=this;

var language = localStorage.Language? localStorage.Language : "en";

var config = {
pageType: "Template/",
pageUrl : "07 Register/07 Register/07 Register.ftl",
lang :language,

successCallback: function(response) {
var res = response.data;
if (res.area_List) {
	
			var Signup = self.cmsRequestFunctions.pluck("Sign_Up_Section",res.area_List);
			self.signupSection = self.cmsRequestFunctions.getAllMapData(Signup[0].component);
			var mobileReg = self.cmsRequestFunctions.pluck("Mobile_Registration",res.area_List);
			self.otpSection = self.cmsRequestFunctions.getAllMapData(mobileReg[0].component);
		    self.countryList=self.signupSection.Country_Code_List;
		    self.countryList.forEach(element => {
			self.cntryCodes.push(element.Country_Code);
		});
			}

},
errorCallback: function(error) {
console.log(error);
}
};
this.cmsRequestFunctions.cmsRequest(config,language);
},



		}
	}
</script>